export const classes = {
  button: {
    add: {
      padding: '0.875rem 1.5rem',
      borderRadius: '0.375rem',
      gap: '0.625rem',
      color: 'black',
      fontFamily: 'Schibsted Grotesk',
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: '1.0625rem',
      letterSpacing: '0em',
      textAlign: 'center',
      textTransform: 'capitalize',
    },
    update: {
      padding: '0.875rem 1.5rem',
      borderRadius: '0.375rem',
      gap: '0.625rem',
      color: 'black',
      fontFamily: 'Schibsted Grotesk',
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: '1.0625rem',
      letterSpacing: '0em',
      textAlign: 'center',
      textTransform: 'capitalize',
    },
    reportType: {
      // width: "137px",
      // length: "38px",
      borderRadius: '2px',
      // padding: '14px 6px 14px 6px',
      padding: '10px 16px 10px 14px',
      gap: '0.625rem',
      color: 'black',
      fontFamily: 'Schibsted Grotesk',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0em',
      textAlign: 'center',
      textTransform: 'capitalize',
    },
    country: {
      // width: "137px",
      // length: "38px",
      borderRadius: '2px',
      // padding: '14px 6px 14px 6px',
      padding: '10px 16px 10px 14px',
      gap: '0.625rem',
      color: 'black',
      fontFamily: 'Schibsted Grotesk',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0em',
      textAlign: 'center',
      textTransform: 'capitalize',
    },
    department: {
      // width: "137px",
      // length: "38px",
      borderRadius: '6px',
      // padding: '14px 6px 14px 6px',
      backgroundColor: '#FFFFFF',
      overflow: 'hidden',
      padding: '10px 16px 10px 14px',
      gap: '0.625rem',
      color: 'black',
      fontFamily: 'Schibsted Grotesk',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0em',
      textAlign: 'center',
      textTransform: 'capitalize',
    },
    customField: {
      // width: "137px",
      // length: "38px",
      borderRadius: '2px',
      // padding: '14px 6px 14px 6px',
      padding: '12px 16px',
      gap: '0.625rem',
      color: 'black',
      fontFamily: 'Schibsted Grotesk',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0em',
      textAlign: 'center',
      textTransform: 'capitalize',
    },
  },
};
